import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('LIST_PRESENTATION', {
  TOGGLE_LIST_VIEW: null
});
